require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-sushma-kaushik.json") })
        }
      }, "path---insights-sushma-kaushik");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-sushma-kaushik!./.cache/json/insights-sushma-kaushik.json
// module id = 1147
// module chunks = 231608221292675